export class HotspotModel {
   
    android_app_url = "https://play.google.com/store/apps/details?id=com.snonosystems.sas_user";
    only_username = false;
    default_pass="";
    pass_equal_user= false;
    allow_new_user= false;
    allow_android_app= false;

}